import * as protoLoader from "@grpc/proto-loader";
import * as grpc from "@grpc/grpc-js";
import {ProtoGrpcType as TelegramAuthGRPCType} from "./generated-types/telegram_auth";
import {ProtoGrpcType as TelegramBotCheckGRPCType} from "./generated-types/telegram_bot_check";
import {ProtoGrpcType as NFLRivalCardGRPCType} from "./generated-types/nfl_rival_card";
import path from "path";

export * from './generated-types/koni_bot/telegram/auth/TelegramAuth';
export * from './generated-types/koni_bot/telegram/auth/TelegramAuthRequest';
export * from './generated-types/koni_bot/telegram/auth/TelegramAuthResponse';
export * from './generated-types/koni_bot/telegram/auth/TelegramParams';
export * from './generated-types/koni_bot/telegram/auth/TelegramUser';
export * from './generated-types/koni_bot/telegram/bot_check/TelegramBotCheck';
export * from './generated-types/koni_bot/telegram/bot_check/TelegramBotCheckRequest';
export * from './generated-types/koni_bot/telegram/bot_check/TelegramBotCheckResponse';
export * from './generated-types/koni_bot/mythical/nfl_rival_card/NflRivalCard';
export * from './generated-types/koni_bot/mythical/nfl_rival_card/CardInfo';
export * from './generated-types/koni_bot/mythical/nfl_rival_card/GetAllCardRequest';
export * from './generated-types/koni_bot/mythical/nfl_rival_card/GetAllCardResponse';
export * from './generated-types/koni_bot/mythical/nfl_rival_card/GetCardByTelegramRequest';
export * from './generated-types/koni_bot/mythical/nfl_rival_card/GetCardByTelegramResponse';

const loadOptions = {
  longs: Number,
  enums: String,
  defaults: true,
}

export const Protocols = {
  telegram: {
    auth: (grpc.loadPackageDefinition(
      protoLoader.loadSync(path.resolve(__dirname, 'proto/telegram_auth.proto'), loadOptions)
    ) as unknown as TelegramAuthGRPCType).koni_bot.telegram.auth,
    bot_check: (grpc.loadPackageDefinition(
      protoLoader.loadSync(path.resolve(__dirname, 'proto/telegram_bot_check.proto'), loadOptions)
    ) as unknown as TelegramBotCheckGRPCType).koni_bot.telegram.bot_check,
  },
  mythical: {
    nfl_rival_card: (grpc.loadPackageDefinition(
      protoLoader.loadSync(path.resolve(__dirname, 'proto/nfl_rival_card.proto'), loadOptions)
    ) as unknown as NFLRivalCardGRPCType).koni_bot.mythical.nfl_rival_card
  }
}

export default Protocols;
